import request from "@/util/http";
/**
 * 检查用户名是否存在
 */
export function check_username(query) {
	return request({
		url: '/upms/shop/merchant_register/check_username',
		method: 'get',
		params: query,
	})
}


/**
 * 检查E-mail是否存在
 */
export function check_email(query) {
	return request({
		url: '/upms/shop/merchant_register/check_email',
		method: 'get',
		params: query,
	})
}


/**
 * 检查手机是否存在
 */
export function check_mobile(query) {
	return request({
		url: '/upms/shop/merchant_register/check_mobile',
		method: 'get',
		params: query,
	})
}

/**
 * 注册页面
 */
export function index(query) {
	return request({
		url: '/upms/shop/merchant_register',
		method: 'get',
		params: query,
	})
}

/**
 * 注册提交
 */
export function submit(data,params) {
	return request({
		url: '/upms/shop/merchant_register/submit',
		method: 'post',
		data:data,
		params: params,
	})
}



// module.exports = {
// 	check_username,
// 	check_email,
// 	check_mobile,
// 	index,
// 	submit,
// }
